// import notificationSoundURL from '~/assets/audio/notification.mp3';

// NOTE: Sounds will be added
export async function playNotificationSound(notificationSound = new Audio(null)) {
  try {
    await notificationSound.play();
  } catch (e) {
    // do nothing
  }
}
